<template>
	<div>
		<div class="spinner-border" v-if="loader" style="margin:auto;display:block;margin-top:60px"/>
		<div class = "col-sm-12 row" v-else>
			<div class = "col-sm-11 vendor-form-wrapper">
				<form v-on:submit.prevent>
					<div class="row" style="border-bottom: 2px solid #3da3a7;margin-bottom: 10px;font-size: 20px;padding: 5px 0px 0px 5px;"><label style="margin: 0px;">Client</label></div>
					<div class = "form-group row">
						<div style = "border:1px #d4d4d4 solid; padding:20px" class = "col-md-11">
							<div class="form-group row">
								<label class="col-sm-3 col-form-label">
									Client
									<sup>*</sup>
								</label>
								<div class="col-sm-7 pr-5" >
									<!-- <input
										v-if = "!isEditPage"
										type="text"
										name="client_name"
										v-model="clientData.client_name"
										class="form-control"
										id="vendor_name"
										placeholder="Enter Client Name"
										autocomplete = "off"
										:class="{ 'is-invalid': submitted && (!clientData.client_name || clientData.client_name == null || clientData.client_name == 'null') }"
									> -->

									<!-- <multiselect
										v-model="clientData.client"
										:options="clientList"
										:searchable="true"
										:loading = "isLoadingClient"
										ref="multiselect"
										label="client_name"
										track-by="client_name"
										@tag="addNewClient"
										open-direction="bottom"
										:taggable="true"
										placeholder="Search..."
										class="form-control multi-dropdown col-md-12"
										style="max-height:42px"
										:multiple="false"
										id="tagData"
									></multiselect> -->


									<multiselect
										v-model="clientData.client"
										:options="clientList"
										label="client_name"
										:searchable="true"
										ref="multiselect"
										track-by="client_name"
										open-direction="bottom"
										class="form-control multi-dropdown"
										placeholder="Select client"
										selectLabel = ""
										deselectLabel = ""
										selectedLabel = ""
										:showLabels = "true"
										tagPlaceholder="Press enter to create new vendor"
										style="max-height:40px;"
										:multiple="false"
										id="mutiselect"
										:loading="isLoadingClient"
										:taggable="true"
										:disabled = "isEditPage && client_id!='' && !calledFromEditBrand"
										@select="selectNewClient"
										@tag="addNewClient"
										:class="{ 'is-invalid': submitted && (!clientData.client || clientData.client == null || clientData.client == 'null' || (clientData.client == {} || clientData.client && (clientData.client.client_name == '' || clientData.client.client_name == undefined))) }"
									/>
									<span
										v-if="submitted && ((!clientData.client || clientData.client == null || clientData.client == 'null' || (clientData.client == {} || clientData.client && (clientData.client.client_name == '' || clientData.client.client_name == undefined))) || (!clientData.client_name || clientData.client_name == null || clientData.client_name == 'null'))"
										class="invalid-feedback"
									>This field is required</span>
								</div>
							</div>
							<div class="form-group row">
								<label class="col-sm-3 col-form-label">Go Retail Contact</label>
								<div class="col-sm-7 pr-5">
									<multiselect
										v-model="clientData.go_retail"
										:options="contacts_list"
										:searchable="true"
										@search-change="updateName"
										ref="multiselect"
										track-by="first_name"
										:custom-label="customLabel"
										open-direction="bottom"
										placeholder="Search..."
										class="form-control multi-dropdown"
										selectLabel
										deselectLabel
										selectedLabel
										tagPlaceholder="Press enter to create new contact"
										autocomplete="off"
										style="max-height:40px;"
										:multiple="false"
										:loading="retailLoader"
										id="retail"
										:taggable="true"
										@select = "selectProfileName($event,'retail')"
										@tag="addNew($event,'retail', index)"
									>
										<template slot="noResult">
											<div @click="addNew('retail', index)">Add new retail contact</div>
										</template>
									</multiselect>
								</div>
							</div>

							<div class="form-group row">
								<label class="col-sm-3 col-form-label">Go Marketing Contact</label>
								<div class="col-sm-7 pr-5">
									<multiselect
										v-model="clientData.go_marketing"
										:options="contacts_list"
										:searchable="true"
										ref="multiselect"
										label="first_name"
										:custom-label="customLabel"
										track-by="first_name"
										open-direction="bottom"
										placeholder="Search..."
										class="form-control multi-dropdown"
										selectLabel
										deselectLabel
										selectedLabel
										autocomplete="off"
										style="max-height:40px;"
										:multiple="false"
										id="market"
										:loading = "marketLoader"
										tagPlaceholder="Press enter to create new contact"
										:taggable="true"
										@select = "selectProfileName($event,'market')"
										@tag="addNew($event,'market', index)"
									>
										<template slot="noResult">
											<div @click="addNew('market', index)">Create new market contact</div>
										</template>
									</multiselect>
								</div>
							</div>
							<div class="form-group row">
								<label class="col-sm-3 col-form-label">Go Ops Contact</label>
								<div class="col-sm-7 pr-5">
									<multiselect
										v-model="clientData.go_ops"
										:options="contacts_list"
										:searchable="true"
										ref="multiselect"
										:custom-label="customLabel"
										label="first_name"
										track-by="first_name"
										open-direction="bottom"
										placeholder="Search..."
										class="form-control multi-dropdown"
										selectLabel
										deselectLabel
										selectedLabel
										autocomplete="off"
										tagPlaceholder="Press enter to create new contact"
										style="max-height:40px;"
										:multiple="false"
										id="ops"
										:loading="opsLoader"
										:taggable="true"
										@select = "selectProfileName($event,'ops')"
										@tag="addNew($event,'ops', index)"
									>
										<template slot="noResult">
											<div @click="addNew('ops', index)">Create new ops contact</div>
										</template>
									</multiselect>
								</div>
							</div>
						</div>
					</div>

					<div class="row" style="border-bottom: 2px solid #3da3a7;margin-bottom: 10px;font-size: 20px;padding: 5px 0px 0px 5px;margin-top:30px"><label style="margin: 0px;">Profiles</label></div>
					<div v-if = "profileData.length">
						<div  v-for = "(profile, index) in profileData" :key="index" class = "form-group row">
							<div style = "border:1px #d4d4d4 solid; padding:20px;margin-bottom:20px" class = "col-md-11" :class = "{'change-color' : (currentProfile == profile.profile_id)}">
								<div class="form-group row">
									<label class="col-sm-3 col-form-label">
										Profile Brand Name
										<sup>*</sup>
									</label>
									<div class="col-sm-7 pr-5">
										<multiselect
											v-model="profile.selected_profile"
											:options="brandsList"
											label="name"
											:searchable="true"
											ref="multiselect"
											track-by="name"
											open-direction="bottom"
											placeholder="Select brand profile"
											class="form-control multi-dropdown"
											selectLabel
											deselectLabel
											selectedLabel
											tagPlaceholder="Press enter to create new brand"
											autocomplete="off"
											:disabled = "currentProfile && profile && profile.selected_profile && currentProfile == profile.selected_profile.id"
											style="max-height:40px;"
											:multiple="false"
											id="brands"
											@select="getBrandForId($event, index)"
											:class="{ 'is-invalid': submitted && (Object.keys(profile.selected_profile).length === 0)}"/>
											<span
												v-if="submitted && (Object.keys(profile.selected_profile).length === 0)"
												class="invalid-feedback"
											>This field is required</span>
									</div>
									<div class = "col-sm-2"><div v-if = "profile.gettingProfileInfo && (index == currentSelectedProfileIndex)" class="spinner-border"></div></div>
								</div>
								<div v-if = "profile.showProfileInfo">
									<div class="form-group row">
										<label class="col-sm-3 col-form-label">
											Brand Entity Id
										</label>
										<div class="col-sm-7 pr-5">
											<input
												v-on:keydown.enter.prevent
												type="text"
												name="entityId"
												v-model="profile.brand_entity_id"
												class="form-control"
												id="entityId"
												placeholder="Enter brand entity id"
												autocomplete = "off"
											>
										</div>
									</div>
									<div class="form-group row">
										<label class="col-sm-3 col-form-label">Vendor</label>
										<div class="col-sm-7 pr-5">
											<multiselect
												v-model="profile.vendor"
												:options="vendorListCopy"
												:searchable="true"
												ref="multiselect"
												label="vendor_name"
												track-by="id"
												open-direction="bottom"
												placeholder="Search..."
												class="form-control multi-dropdown"
												selectLabel
												deselectLabel
												selectedLabel
												autocomplete="off"
												tagPlaceholder="Press enter to create new vendor"
												style="max-height:40px;"
												:multiple="false"
												id="vendor"
												:taggable="true"
												@select = "pushVendorToVendor($event, index, 'profile')"
												@tag = "addNewVendorToProfile(index)"
											>
												<template slot="noResult">
													<div @click="addNewVendorToProfile(index)">Create new vendor</div>
												</template>
											</multiselect>
										</div>
									</div>
									<div class="form-group row">
										<label class="col-sm-3 col-form-label">
											Country
										</label>
										<div class="col-sm-7 pr-5">
											<input
												v-on:keydown.enter.prevent
												type="text"
												name="entityId"
												v-model="profile.country_code"
												class="form-control"
												id="entityId"
												placeholder="Enter country code"
												autocomplete = "off"
											>
										</div>
									</div>
									<div class="form-group row">
										<label class="col-sm-3 col-form-label">
											Base Api Url
										</label>
										<div class="col-sm-7 pr-5">
											<input
												v-on:keydown.enter.prevent
												type="text"
												name="baseApiUrl"
												v-model="profile.base_api_url"
												class="form-control"
												id="baseApiUrl"
												placeholder="Enter base api url"
												autocomplete = "off"
											>
										</div>
									</div>
									<div class="form-group row">
										<label class="col-sm-3 col-form-label">Marketing Campaign Type</label>
										<div class="col-sm-9">
											<div class="form-check d-inline-block">
												<input
													type="checkbox"
													v-model="profile.marketing_campaign_sb"
													value="true"
													class="form-check-input"
													id="exampleCheck1"
													autocomplete = "off"
												>
												<label
													class="form-check-label"
													for="dataPull1"
													style="vertical-align: middle !important;"
												>Sponsored Brands</label>
											</div>
											<div class="form-check d-inline-block ml-3" style="margin-left:24px !important">
												<input
													type="checkbox"
													v-model="profile.marketing_campaign_sp"
													value="true"
													class="form-check-input"
													id="exampleCheck1"
													autocomplete = "off"
												>
												<label
													class="form-check-label"
													for="dataPull2"
													style="vertical-align: middle !important;"
												>Sponsored Products</label>
											</div>
											<div class="form-check d-inline-block ml-3" style="margin-left:24px !important">
												<input
													type="checkbox"
													v-model="profile.marketing_campaign_sd"
													value="true"
													class="form-check-input"
													id="exampleCheck1"
													autocomplete = "off"
												>
												<label
													class="form-check-label"
													for="dataPull2"
													style="vertical-align: middle !important;"
												>Sponsored Display</label>
											</div>
										</div>
									</div>
									<!-- <div class="form-group row">
										<label class="col-sm-3 col-form-label">ARA</label>
										<div class="col-sm-7">
											<div class="form-check d-inline-block">
												<input
													class="form-check-input"
													v-model="profile.ara_type"
													type="radio"
													name="AraType"
													id="AraType"
													value="Basic"
													autocomplete = "off"
												>
												<label
													class="form-check-label"
													for="TargetingType1"
													style="vertical-align: middle !important;"
												>Basic</label>
											</div>
											<div class="form-check d-inline-block ml-3">
												<input
													class="form-check-input"
													v-model="profile.ara_type"
													type="radio"
													name="AraType"
													id="AraType"
													value="Premium"
													autocomplete = "off"
												>
												<label
													class="form-check-label"
													for="TargetingType2"
													style="vertical-align: middle !important;"
												>Premium</label>
											</div>
										</div>
									</div> -->
									<div class="form-group row">
										<label class="col-sm-3 col-form-label">Profile Type</label>
										<div class="col-sm-7">
											<div class="form-check d-inline-block">
												<input
													type="checkbox"
													v-model="profile.profile_type_seller"
													value="true"
													class="form-check-input"
													id="exampleCheck1"
													autocomplete = "off"
												>
												<label
													class="form-check-label"
													for="TargetingType1"
													style="vertical-align: middle !important;"
												>Seller</label>
											</div>
											<div class="form-check d-inline-block ml-3">
												<input
													type="checkbox"
													v-model="profile.profile_type_vendor"
													value="true"
													class="form-check-input"
													id="exampleCheck1"
													autocomplete = "off"
												>
												<label
													class="form-check-label"
													for="TargetingType2"
													style="vertical-align: middle !important;"
												>Vendor</label>
											</div>
										</div>
									</div>
									<!-- <div class="form-group row">
										<label class="col-sm-3 col-form-label">Client Main Contact</label>
										<div class="col-sm-7 pr-5">
											<multiselect
												v-model="profile.client_main_contact"
												:options="contacts_list"
												:searchable="true"
												ref="multiselect"
												:custom-label="customLabel"
												label="first_name"
												track-by="first_name"
												open-direction="bottom"
												placeholder="Search..."
												class="form-control multi-dropdown"
												selectLabel
												deselectLabel
												selectedLabel
												autocomplete="off"
												style="max-height:40px;"
												:multiple="false"
												id="clsient"
												:loading="clientLoader"
												:taggable="true"
												tagPlaceholder="Press enter to create new contact"
												@select = "selectProfileName($event,'client', index)"
												@tag="addNew($event,'client', index)"
											>
												<template slot="noResult">
													<div @click="addNew('client', index)">Add new client contact</div>
												</template>
											</multiselect>
										</div>
									</div> -->


									<div class="form-group row">
										<label class="col-sm-3 col-form-label">Data pull</label>
										<div class="col-sm-7">
											<div class="form-check d-inline-block">
												<input
													class="form-check-input"
													v-model="profile.data_pull"
													type="radio"
													name="DataPull"
													id="DataPull"
													:value='true'
													autocomplete = "off"
												>
												<label
													class="form-check-label"
													for="Type1"
													style="vertical-align: middle !important;"
												>True</label>
											</div>
											<div class="form-check d-inline-block ml-3">
												<input
													class="form-check-input"
													v-model="profile.data_pull"
													type="radio"
													name="DataPull"
													id="DataPull"
													:value="false"
													autocomplete = "off"
												>
												<label
													class="form-check-label"
													for="Type2"
													style="vertical-align: middle !important;"
												>False</label>
											</div>
										</div>
									</div>
									<div class="form-group row">
										<label class="col-sm-3 col-form-label">
											Annual Goal
										</label>
										<div class="col-sm-7 pr-5">
											<input
												type="number"
												name="annualGoal"
												v-model="profile.annual_goal"
												class="form-control"
												id="entityId"
												placeholder="Enter Annual Goal"
												autocomplete = "off"
												min="0"
												onkeypress="return event.charCode != 45"
											>
										</div>
									</div>
									<div class="form-group row" style="padding-left:0px">
										<div class="col-sm-3 col-form-label">
											<label class="form-check-label">FBA</label>
										</div>
										<div class="col-sm-7">
											<div class="form-check d-inline-block" style="display:flex !important">
												<input
													type="checkbox"
													v-model="profile.fba"
													value="true"
													style="padding-bottom:5px"
													class="form-check-input"
													id="exampleCheck1"
													autocomplete = "off"
												>
											</div>
										</div>
									</div>
									<div class="form-group row">
										<label class="col-sm-3 col-form-label">
											Monthly Budget
										</label>
										<div class="col-sm-7 pr-5">
											<input
												type="number"
												name="baseApiUrl"
												v-model="profile.monthly_budget"
												class="form-control"
												id="baseApiUrl"
												placeholder="Enter Monthly Budget"
												autocomplete = "off"
												min="0"
												onkeypress="return event.charCode != 45"
											>
										</div>
									</div>
									<div class="form-group row" style="padding-left:0px">
										<div class="col-sm-3 col-form-label">
											<label class="form-check-label" for="exampleCheck1">Active</label>
										</div>
										<div class="col-sm-1">
											<div class="form-check d-inline-block" style="display:flex !important">
												<input
													type="checkbox"
													v-model="profile.active"
													value="true"
													style="padding-bottom:5px"
													class="form-check-input"
													id="exampleCheck1"
													autocomplete = "off"
													@click = "activeValueChange($event, index)"
												>
											</div>
										</div>
										<div class = "col-sm-6 form-group row" v-if = "profile.showDate">
											<div class="col-sm-5 col-form-label" style = "padding-top:0px">
												<label class="form-check-label" for="exampleCheck1">{{ifDisabledOnPastDate(profile.disable_date)?'Disabled On	'+ setDateFormat(profile.disable_date):'Future Date To Disable'}}</label>
												<p style = "font-size:13px;color:red" v-if="!ifDisabledOnPastDate(profile.disable_date)">(Update will happen at 11:59pm on selected date)</p>
											</div>
											<div class="col-sm-7" style="padding-top:0px">

												<b-form-datepicker
												    :id="index + '_disable'"
													name="disable_date"
													placeholder="MM-DD-YYYY"
													class="date_wrapper"
													v-model="profile.disable_date"
													menu-class="w-100"
													size="sm"
													:date-format-options="{day: '2-digit',  month: '2-digit',  year: 'numeric' }"
													calendar-width="180%"
													:hide-header="true"
													:today-button = "false"
													:min="min_date_disable" locale="en"
													v-if="!ifDisabledOnPastDate(profile.disable_date)"
												>
												</b-form-datepicker>
											</div>
										</div>
										<div class="col-sm-2" style = "text-align:center" v-if = "profile.showDate && profileData.disable_date">
											<p style = "font-size:13px;color:orange">Pending InActive</p>
										</div>
									</div>
								</div>
							</div>
							<div style = "" class = "col-sm-1">
								<button
									v-if = "currentProfile != profile.profile_id"
									@click="removeProfileToList(index)"
									class="btn btn-primary add-new-campaign"
									style="background-color:red"
								>X</button>
							</div>
							<div class = "form-group row" style = "margin-left:0px;">
								<button
									class="btn btn-primary add-new-campaign"
									v-if = "(profileData.length - 1 == index)"
									@click="addProfileToList()"
								>
								Add Profile
								</button>
							</div>
						</div>
					</div>
					<div v-else class = "form-group row">
						<button
							class="btn btn-primary add-new-campaign"
							@click="addProfileToList()"
						>
						Add Profile
						</button>
					</div>


					<div class="row" style="border-bottom: 2px solid #3da3a7;margin-bottom: 10px;font-size: 20px;padding: 5px 0px 0px 5px;margin-top:30px"><label style="margin: 0px;">Vendors</label></div>
					<div v-if = "vendorData.length">
						<div v-for = "(vendor, index) in vendorData" class = "form-group row">
							<div style = "border:1px #d4d4d4 solid; padding:20px" class = "col-md-11" :key = "index + '_vendor'">
								<div class="form-group row">
									<label class="col-sm-3 col-form-label">
										Vendor Name
										<sup>*</sup>
									</label>
									<div class="col-sm-7 pr-5">
										<span
											class = "no-data-style"
											v-if = "ispreviouslySelectedVendor == index && ispreviouslySelectedVendor !=''">
											This vendor is already selected please choose another one
										</span>
										<multiselect
											v-model="vendor.vendor"
											:options="vendorList"
											label="vendor_name"
											:searchable="true"
											ref="multiselect"
											track-by="vendor_name"
											open-direction="bottom"
											placeholder="Select vendor"
											class="form-control multi-dropdown"
											:showLabels = "true"
											selectLabel = ""
											deselectLabel = ""
											selectedLabel = ""
											tagPlaceholder="Press enter to create new vendor"
											autocomplete="off"
											style="max-height:40px;"
											:multiple="false"
											id="vendor_name"
											:loading="isLoading"
											:taggable="true"
											@select="selectNewVendor($event, index)"
											@tag="addNewVendor($event, index)"
											@remove = "removeSelectedVendor($event, index)"
											:class="{ 'is-invalid': submitted &&( !vendor.vendor || (!vendor.vendor.vendor_name))}"
										/>
										<span
											v-if="submitted && (!vendor.vendor || !vendor.vendor.vendor_name || !vendorData || !vendorData.vendor_name)"
											class="invalid-feedback"
										>This field is required</span>
									</div>
								</div>
								<div v-if = "vendor.showVendorData">
									<div class="form-group row">
										<label class="col-sm-3 col-form-label">
											VC Alias
										</label>

										<div class="col-sm-7 pr-5">
											<input
												type="text"
												name="vc_alias"
												v-model="vendor.vc_alias"
												class="form-control"
												id="vc_alias"
												placeholder="Enter vc alias"
												autocomplete = "off"
												@keydown = "inputClicked"
												v-on:keydown.enter.prevent
											>
										</div>
									</div>
									<div class="form-group row">
										<label class="col-sm-3 col-form-label">Account Type</label>
										<div class="col-sm-7">
											<div class="form-check d-inline-block">
												<input
													type="radio"
													v-model="vendor.account_type"
													value="Basic"
													class="form-check-input"
													id="exampleCheck1"
													autocomplete = "off"
												>
												<label
													class="form-check-label"
													for="TargetingType1"
													style="vertical-align: middle !important;"
												>Basic</label>
											</div>
											<div class="form-check d-inline-block ml-3">
												<input
													type="radio"
													v-model="vendor.account_type"
													value="Premium"
													class="form-check-input"
													id="exampleCheck1"
													autocomplete = "off"
												>
												<label
													class="form-check-label"
													for="TargetingType2"
													style="vertical-align: middle !important;"
												>Premium</label>
											</div>
										</div>
									</div>
									<div class = "form-group row">
										<div class="col-sm-3 col-form-label" style = "padding-top:0px">
											<label class="form-check-label" for="exampleCheck1">Reporting date</label>
										</div>
										<div class="col-sm-5" style="padding-top:0px">
												<b-form-datepicker
													:id="'start' + '_' + index "
													placeholder="MM-DD-YY"
													name="reporting_date"
													v-model="vendor.reporting_date"
													class="date_wrapper"
													size="sm"
													:date-format-options="{day: '2-digit',  month: '2-digit',  year: 'numeric' }"
													calendar-width="130%"
													:hide-header="true"
													:min="min_date" locale="en">
												</b-form-datepicker>
										</div>
									</div>
								</div>

							</div>
							<div style = "" class = "col-sm-1" v-if = "!vendor.isRemove">
								<button
									@click="removeVendorFromList(index)"
									class="btn btn-primary add-new-campaign"
									style="background-color:red"
								>X</button>
							</div>
							<div v-else class = "col-sm-1"></div>
							<div class = "form-group row" style = "margin-top:10px;margin-bottom:10px;margin-left:0px;">
								<button
									class="btn btn-primary add-new-campaign"
									v-if = "(vendorData.length - 1 == index)"
									@click="addVendorToList()"
								>
								Add Vendor
								</button>
							</div>
						</div>
					</div>
					<div v-else class = "form-group row">
						<button
							class="btn btn-primary add-new-campaign"
							@click="addVendorToList()"
						>
						Add Vendor
						</button>
					</div>

					<div class="row" style="border-bottom: 2px solid #3da3a7;margin-bottom: 10px;font-size: 20px;padding: 5px 0px 0px 5px;margin-top:30px"><label style="margin: 0px;">Sellers</label></div>
					<div v-if ="sellerData.length">
						<div v-for = "(seller, index) in sellerData" class = "form-group row">
							<div style = "border:1px #d4d4d4 solid; padding:20px" class = "col-md-11">
								<div class="form-group row">
									<label class="col-sm-3 col-form-label">
										Merchant Name
										<sup>*</sup>
									</label>
									<div class="col-sm-7 pr-5">
										<span
											class = "no-data-style"
											v-if = "seller.duplicateNameKeyPair">
											Merchant with same name already exists, please assign different merchant id
										</span>
										<multiselect
											v-model="seller.merchant_name"
											:options="merchantList"
											label="merchant_name"
											:searchable="true"
											ref="multiselect"
											track-by="merchant_name"
											open-direction="bottom"
											placeholder="Select merchant"
											class="form-control multi-dropdown"
											selectLabel = ""
											deselectLabel = ""
											selectedLabel = ""
											tagPlaceholder="Press enter to create new vendor"
											autocomplete="off"
											style="max-height:40px;"
											:multiple="false"
											id="merchant_name"
											:taggable="true"
											@tag = "addNewMerchant($event, index)"
											@select = "selectMerchantName($event, index)"
											@remove = "removeSelectedSeller($event, index)"
										/>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-sm-3 col-form-label">
										Merchant Id
										<sup>*</sup>
									</label>
									<div class="col-sm-7 pr-5">
										<input
											v-on:keydown.enter.prevent
											type="text"
											name="merchant_id"
											v-model="seller.merchant_id"
											class="form-control"
											id="merchant_id"
											placeholder="Enter merchant id"
											autocomplete = "off"
											v-on:input = "checkDuplicasy($event, index)"
											:class="{ 'is-invalid': submitted && (!seller.merchant_id || seller.merchant_id == '')}"
										>
										<span
											v-if="submitted && (!seller.merchant_id || seller.merchant_id == '')"
											class="invalid-feedback"
										>This field is required</span>

									</div>
								</div>
								<div class="form-group row">
									<label class="col-sm-3 col-form-label">Vendor</label>
									<div class="col-sm-7 pr-5">
										<multiselect
											v-model="seller.vendor"
											:options="vendorListCopy"
											:searchable="true"
											ref="multiselect"
											label="vendor_name"
											track-by="id"
											open-direction="bottom"
											placeholder="Search..."
											class="form-control multi-dropdown"
											selectLabel
											deselectLabel
											selectedLabel
											autocomplete="off"
											tagPlaceholder="Press enter to create new vendor"
											style="max-height:40px;"
											:multiple="false"
											id="vendor"
											:taggable="true"
											@tag = "addNewVendorToSellerFromPopUp(index)"
											@select = "pushVendorToVendor($event, index, 'seller')"

										>
											<template slot="noResult">
												<div @click="addNewVendorToSellerFromPopUp(index)">Create new vendor</div>
											</template>
										</multiselect>
									</div>
								</div>
								<!-- <div class="form-group row">
									<label class="col-sm-3 col-form-label">
										Vendor Name
										<sup>*</sup>
									</label>
									<div class="col-sm-7 pr-5">
										<multiselect
											v-model="seller.vendor"
											:options="vendorList"
											label="vendor_name"
											:searchable="true"
											ref="multiselect"
											track-by="vendor_name"
											open-direction="bottom"
											placeholder="Select vendor"
											class="form-control multi-dropdown"
											selectLabel
											deselectLabel
											selectedLabel
											tagPlaceholder="Press enter to create new vendor"
											autocomplete="off"
											style="max-height:40px;"
											:multiple="false"
											id="vendor_name"
											:taggable="true"
											:loading = "isVendorSellerLoading"
											@tag="addNewVendorToSeller($event, index)"
											@select = "selectVendorForSeller($event, index)"
										/>
									</div>
								</div> -->
								<!-- <div class="form-group row">
									<label class="col-sm-3 col-form-label">Merchant Type</label>
									<div class="col-sm-7">
										<div class="form-check d-inline-block">
											<input
												type="radio"
												v-model="seller.merchant_type"
												value="Seller"
												class="form-check-input"
												id="exampleCheck1"
												autocomplete = "off"
											>
											<label
												class="form-check-label"
												for="TargetingType1"
												style="vertical-align: middle !important;"
											>Seller</label>
										</div>
										<div class="form-check d-inline-block ml-3">
											<input
												type="radio"
												v-model="seller.merchant_type"
												value="Vendor"
												class="form-check-input"
												id="exampleCheck1"
												autocomplete = "off"
											>
											<label
												class="form-check-label"
												for="TargetingType2"
												style="vertical-align: middle !important;"
											>Vendor</label>
										</div>
									</div>
								</div> -->
								<div class="form-group row">
									<label class="col-sm-3 col-form-label">
										Country
									</label>
									<div class="col-sm-7 pr-5">
										<multiselect
											v-model="seller.country_code"
											:options="countryList"
											label="market_place"
											:searchable="true"
											ref="multiselect"
											track-by="country_code"
											open-direction="bottom"
											placeholder="Select country"
											class="form-control multi-dropdown"
											selectLabel = ""
											deselectLabel = ""
											selectedLabel = ""
											tagPlaceholder="Press enter to create new vendor"
											autocomplete="off"
											style="max-height:40px;"
											:multiple="false"
											id="country_code"
											:taggable="true"
										/>
										<!-- <input
											v-on:keydown.enter.prevent
											type="text"
											name="entityId"
											v-model="seller.country_code"
											class="form-control"
											id="entityId"
											placeholder="Enter country code"
											autocomplete = "off"
										> -->
									</div>
								</div>
								<!-- <div class="form-group row">
									<label class="col-sm-3 col-form-label">
										Market Place Id
									</label>
									<div class="col-sm-7 pr-5">
										<input
											v-on:keydown.enter.prevent
											type="text"
											name="entityId"
											v-model="seller.marketplace_id"
											class="form-control"
											id="entityId"
											placeholder="Enter market place id"
											autocomplete = "off"
										>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-sm-3 col-form-label">
										Market Place URL
									</label>
									<div class="col-sm-7 pr-5">
										<input
											v-on:keydown.enter.prevent
											type="text"
											name="entityId"
											v-model="seller.marketplace_url"
											class="form-control"
											id="entityId"
											placeholder="Enter market place url"
											autocomplete = "off"
										>
									</div>
								</div> -->
								<!-- <div class="form-group row">
									<label class="col-sm-3 col-form-label">
										Access Key Id
									</label>
									<div class="col-sm-7 pr-5">
										<input
											v-on:keydown.enter.prevent
											type="text"
											name="entityId"
											v-model="seller.access_key_id"
											class="form-control"
											id="entityId"
											placeholder="Enter access key id"
											autocomplete = "off"
										>
									</div>
								</div> -->
								<!-- <div class="form-group row">
									<label class="col-sm-3 col-form-label">
										Sercet Access Key
									</label>
									<div class="col-sm-7 pr-5">
										<input
											v-on:keydown.enter.prevent
											type="text"
											name="entityId"
											v-model="seller.secret_access_key"
											class="form-control"
											id="entityId"
											placeholder="Enter secret access key"
											autocomplete = "off"
										>
									</div>
								</div> -->
								<div class="form-group row">
									<label class="col-sm-3 col-form-label">
										Seller Auth Dev Token
									</label>
									<div class="col-sm-7 pr-5">
										<input
											v-on:keydown.enter.prevent
											type="text"
											name="entityId"
											v-model="seller.seller_dev_auth_token"
											class="form-control"
											id="entityId"
											placeholder="Enter seller dev auth token"
											autocomplete = "off"
										>
									</div>
								</div>
							</div>
							<div class = "col-sm-1">
								<button
									@click="removeSellerFromList(index)"
									class="btn btn-primary add-new-campaign"
									style="background-color:red"
								>X</button>
							</div>
							<div class = "form-group row" style = "margin-top:10px;margin-bottom:10px;margin-left:0px">
								<button
									class="btn btn-primary add-new-campaign"
									v-if = "(sellerData.length - 1 == index)"
									@click="addSellerToList()"
								>
								Add Seller
								</button>
							</div>
						</div>
					</div>
					<div v-else class = "form-group row">
						<button
							class="btn btn-primary add-new-campaign"
							@click="addSellerToList()"
						>
						Add Seller
						</button>
					</div>




					<div class="form-group text-center" style = "margin-top:20px;margin-bottom:20px">
						<button class="btn btn-secondary" @click="navigateToListPage('cancel')">Cancel</button>
						<button class="btn btn-primary" @click="saveVendor()">Save</button>
					</div>

				</form>
			</div>
		</div>
		<AddContactModal
			v-if="openAddNewContactModal"
			@closeAddContactModal="closeAddContactModal"
			:addedNewName="addedNewName"
		/>
		<VendorPopUp
			:vendorAddedToProfileIndex = "vendorAddedToProfileIndex"
			:vendorAddedType = "vendorAddedType"
			@addVendorToType = "addVendorToType"
			:client_id = "clientData.client && clientData.client.client_id ? clientData.client.client_id : ''"
		/>

	</div>
	</div>
</template>

<script>
	import Multiselect from "vue-multiselect";
	import AddContactModal from "@/components/account-management/AddContactModal";
	import VendorPopUp from "@/components/account-management/VendorPopUp.vue";
	import moment from "moment";
	import datePicker from 'vue-bootstrap-datetimepicker';


	export default {
		name: "AddVendorForm",
		data() {
			return{
				custom:'2020-08-12',
				options: {
					format: 'DD/MM/YYYY',
					useCurrent: false,
				}  ,
				clientData:{
					client:null,
					client_name:"",
					go_ops:"",
					go_marketing:"",
					go_retail:""
				},
				vendorData:[{
					go_vendor_cd:"",
					vendor_name:"",
					vc_alias:"",
					account_type:"",
					reporting_date:"",
					vendor:null,
					showVendorData:false,
					isRemove:false,
					forProfile:'',
					forSeller:''
				}],
				sellerData:[{
					id:"",
					merchant_id:"",
					merchant_type:"",
					country_code:null,
					marketplace_id:"",
					marketplace_url:"",
					access_key_id:"",
					secret_access_key:"",
					seller_dev_auth_token:"",
					vendor:null,
					merchant_name:null,
					duplicateNameKeyPair:false
				}],
				profileData:[{
					profile_id: "",
					vendor: {},
					go_vendor_cd: "",
					ams_profile_id: "",
					brand_entity_id: "",
					profile_brand_name: "",
					active: true,
					country_code: "",
					base_api_url: "",
					profile_type_seller: "",
					profile_type_vendor: "",
					marketing_campaign_sp: "",
					marketing_campaign_sb: "",
					marketing_campaign_sd: "",
					ara_type: "",
					client_main_contact: "",
					profile_type: "",
					data_pull: "",
					go_marketing: "",
					annual_goal: '',
					fba:'',
					montly_budget:'',
					disable_date:'',
					selected_profile:null,
					showProfileInfo:false,
					gettingProfileInfo:false,
					showDate:false
				}],
				isEditPage: false,
				brandsList:[],
				addedNewName: "",
				openAddNewContactModal: false,
				addedType: "",
				contacts_list:[],
				selected_profile:{},
				client_id:"",
				loader:false,
				vendorList:[],
				vendorListCopy:[],
				isLoading:false,
				isLoadingClient:false,
				clientList:[],
				isVendorSellerLoading:false,
				submitted:false,
				currentSelectedProfileIndex:-1,
				brandProfileId:null,
				clientLoader:false,
				marketLoader:false,
				opsLoader:false,
				retailLoader:false,
				currentProfile:'',
				countryList:[],
				merchantList:[],
				selectedAllSellersList:[],
				merchantListCopy:[],
				duplicateNameKeyPair:'',
				tempCurrentBrnadProfile:{},
				calledFromEditBrand:false,
				ispreviouslySelectedVendor:'',
				selectedAllVendorsList:[],
				vendorAddedToProfileIndex:'',
				brandListCopy:[],
				vendorAddedType:'',
				vendorSellerAddedList:[]
			}
		},
		components:{
			Multiselect,
			AddContactModal,
			datePicker,
			AddContactModal,
			VendorPopUp
		},
		computed:{
			min_date(){
				return  moment().format("YYYY-MM-DD");
			},
			min_date_disable(){
				//only allow future dates, will prevent past as well as current date from selection
				return  moment().add(1,'days').format("YYYY-MM-DD");
			}
		},
		watch: {
			isEditPage() {
				if (this.isEditPage) {
					this.getProfileData();
				}
			},
		},
		mounted(){
			this.getBrandsList();
			this.getVendorList();
			this.getContactsList();
			this.getAllClient();
			this.getCountryList();
			this.getMerchantList();

			this.currentProfile = this.$route.params.profile;
			//we will call this fn from brand list.
			//this.checkIsEdit();
		},
		methods:{
			moment,
			ifDisabledOnPastDate(disableDate){
				//if disabled date is same or before current date, consider it as disabed & return true
				let x = moment(disableDate).isSameOrBefore(moment())
				return x
			},
			stopPropagation(e){
				e.preventDefault()
			},
			inputClicked(event){
				//if(event.code == 'Enter'){
					event.stopPropagation();
				//}
			},
			setDateFormat(date){
				return moment().format('MM/DD/YYYY')
			},
			checkIsEdit(){
				let id = this.$route.params.ProfileId;
				let brandId = this.$route.params.BrandProfileId;
				if(id){
					this.client_id = id
					this.isEditPage = true;
				}
				else if(brandId){
					this.client_id = ""
					this.brandProfileId = brandId
					this.isEditPage = true
				}
				else{
					this.isEditPage = false;
				}
			},
			getBrandsList(){
				let vm = this;
				this.$store.dispatch("getAllBrandProfile").then((res) => {
					vm.brandsList = res;
					vm.brandListCopy = JSON.parse(JSON.stringify(res))
					vm.checkIsEdit();
				})
			},
			getBrandForId(data, index){
				this.resetWithNewProfile(index)
				let vm = this;
				var pay = {
					profile_id: data.id
				};
				this.currentSelectedProfileIndex = index
				this.profileData[index].gettingProfileInfo = true;
				this.profileData.splice(0,0);
			//	vm.profileData[index] = [];
				this.$store.dispatch("accounts/getVendorDataById",pay).then((res) => {
					vm.profileData[index] = res;
					vm.tempCurrentBrnadProfile = res;

					vm.profileData[index].selected_profile = {name:data.name, id:data.id}
					vm.profileData[index].gettingProfileInfo = false;

					let addedProfile = vm.brandsList.find((e) => res.profile_brand_name == e.name)
					let addIndex = vm.brandsList.indexOf(addedProfile)
					vm.brandsList.splice(addIndex,1)

					if(vm.profileData && vm.profileData[index].disable_date){
						vm.profileData[index].showDate = true;
						vm.profileData[index].disable_date = moment(res.disable_date).utc().format("YYYY-MM-DD")
					}
					else{
						vm.profileData[index].showDate = false;
					}
					vm.currentSelectedProfileIndex = -1;
					vm.profileData[index].showProfileInfo = true;
					vm.profileData.splice(0,0)
				})
			},
			addNew(val, type) {
				this.addedNewName = val;
				this.openAddNewContactModal = true;
				this.addedType = type;
			},
			addNewVendorToProfile(index){
				this.vendorAddedToProfileIndex = index
				this.vendorAddedType = 'profile'
				 $("#vendorPopUp").modal('show');
			},
			addNewVendorToSellerFromPopUp(index){
				this.vendorAddedToProfileIndex = index
				this.vendorAddedType = 'seller'
				 $("#vendorPopUp").modal('show');
			},
			addVendorToType(vendor, type, index, newVendor){

				if(type == 'profile'){
					this.profileData[index].vendor = newVendor
				}
				if(type == 'seller'){
					this.sellerData[index].vendor = newVendor
				}

				vendor.isRemove = true,
				vendor.showVendorData = true
				this.vendorData.push(newVendor)
				this.vendorListCopy.push(newVendor)

				this.resetVendorPopUpData()

			},
			pushVendorToVendor(data, index, type){
				data.isRemove = true
				data.showVendorData = true

			//	this.vendorSellerAddedList.push(data)


				if(type == 'profile'){
					data.forProfile = index
					this.vendorData.forEach((e, i) =>{
						if(e.forProfile == index){
							this.vendorData.splice(index, 1)
						}
					})
				}
				else if(type == 'seller'){
					data.forSeller = index
					this.vendorData.forEach((e, i) =>{
						if(e.forSeller == index){
							this.vendorData.splice(index, 1)
						}
					})
				}

				data.vendor = data

				let ispresent = this.vendorData.find((e) => e.vendor_name.toLowerCase() == data.vendor_name.toLowerCase())
				if(!ispresent){
					this.vendorData.push(data)
				}
			},
			resetVendorPopUpData(){
				 $("#vendorPopUp").modal('hide');
				this.vendorAddedToProfileIndex = ''
				this.vendorAddedType = ''
			},
			selectProfileName(val, type){
					switch (type) {
						case "client":
							this.clientLoader = true
							this.clientData.client_main_contact = JSON.parse(JSON.stringify(val));
							this.clientLoader = false
							break;
						case "market":
							this.marketLoader = true
							this.clientData.go_marketing = JSON.parse(JSON.stringify(val));
							this.marketLoader = false
							break;
						case "ops":
							this.opsLoader = true
							this.clientData.go_ops = JSON.parse(JSON.stringify(val));
							this.opsLoader = false
							break;
						case "retail":
							this.retailLoader = true
							this.clientData.go_retail = JSON.parse(JSON.stringify(val));
							this.retailLoader = false
							break;
					}
			},
			closeAddContactModal(data) {
				this.addedNewName = "";
				this.openAddNewContactModal = false;
				if (data.length) {
					switch (this.addedType) {
						case "client":
							this.clientData.client_main_contact = data[0];
							break;
						case "market":
							this.clientData.go_marketing = data[0];
							break;
						case "ops":
							this.clientData.go_ops = data[0];
							break;
						case "retail":
							this.clientData.go_retail = data[0];
							break;
					}
				}
			},
			activeValueChange(val, index){
				let data = JSON.parse(JSON.stringify(this.profileData))
				if(!val.currentTarget.checked){
					data[index].showDate = true;
				}
				else{
					data[index].showDate = false;
					data[index].disable_date = '';
				}
				this.profileData = JSON.parse(JSON.stringify(data))
			},
			customLabel(data) {
				if (!data.last_name) {
					return data.first_name;
				} else {
					return data.first_name + " " + data.last_name;
				}
			},
			getContactsList() {
				let payload = { q: "" };
				let vm = this;
				this.$store
					.dispatch("accounts/getContactsList", payload)
					.then(res => {
						vm.contacts_list = res;
					});
			},
			saveVendor(){
				let vm = this;
				this.submitted = true;
				if (this.validate()) {

					// this.profileData = this.profileData.map((e) => {
					// 	e.go_retail = (e.go_retail || {}).id || e.go_retail;
					// 	if(e.go_retail == undefined){
					// 		e.go_retail = null
					// 	}
					// 	e.go_ops = (e.go_ops || {}).id || e.go_ops;
					// 	if(e.go_ops == undefined){
					// 		e.go_ops = null
					// 	}
					// 	e.go_marketing = (e.go_marketing || {}).id || e.go_marketing;
					// 	if(e.go_marketing == undefined){
					// 		e.go_marketing = null
					// 	}
					// 	e.client_main_contact = (e.client_main_contact || {}).id || e.client_main_contact;
					// 	if(e.client_main_contact == undefined){
					// 		e.client_main_contact = null
					// 	}
					// 	return e
					// })

					if(this.clientData.client && this.clientData.client.client_id){
						this.$store.state.selectedClientFilter = this.clientData.client.client_id
					}


					let payload = {
						clientData:this.clientData,
						vendorData:this.vendorData,
						sellerData:this.sellerData,
						profileData:this.profileData,
						isEdit:(this.isEditPage ? (this.brandProfileId ? false : true) : false)
					}
					this.loader = true;

					this.$store.dispatch("accounts/storeVendorData", payload).then((res) => {
						vm.loader = true;
						vm.navigateToListPage();
					})
				}
				else{

				}

			},
			updateName(query) {
				this.name = query;
			},
			navigateToListPage(data) {
				if (data == "cancel") {
					this.$store.state.calledFromCancel = true;
				}
				this.$router.push({ path: "/accounts" });
			},
			getProfileData(){

				if(this.client_id){
						this.loader = true;
						let vm = this;
						this.$store.dispatch("accounts/getDetails", {client_id:this.client_id}).then((res) => {
						vm.loader = false;
						vm.vendorData = (res && res.vendorData && res.vendorData.length ? res.vendorData : []);
						vm.sellerData = (res && res.sellerData && res.sellerData.length ? res.sellerData : []);
						vm.profileData = (res && res.profileData && res.profileData.length ? res.profileData : []);
						if(Object.keys(vm.tempCurrentBrnadProfile).length){
							vm.profileData.push(vm.tempCurrentBrnadProfile)
						}
						if(vm.profileData.length && vm.profileData.length>1){
							let data = vm.profileData.find((e) => e.profile_id == vm.currentProfile)
							let index = vm.profileData.indexOf(data)
							vm.profileData.splice(index, 1)
							vm.profileData.unshift(data)
						}
						vm.clientData = res && res.clientData && res.clientData.length ? res.clientData[0] :	{client:{},client_name:""};
						vm.clientData.client = {client_name:vm.clientData.client_name, client_id:vm.clientData.client_id}
						vm.selected_profile = {name:res.profileData.profile_brand_name};
						if(vm.sellerData.length){
							vm.showVendorForSeller(vm.sellerData)
							vm.showMerchantName()
						}
						if(vm.profileData.length){
							vm.showProfileForClient(vm.profileData)
						}


						vm.showProfileInfo = true;
						// vm.vendorData.reporting_date = res.vendorData.reporting_startdate ? moment(res.vendorData.reporting_startdate).utc().format("YYYY-MM-DD") : "";
						// if(res.profileData.disable_date){
						// 	vm.profileData[index].showDate = true;
						// 	vm.profileData.disable_date = moment(res.profileData.disable_date).utc().format("YYYY-MM-DD")
						// }
						// vm.profileData.disable_date = res.profileData.disable_date ? moment(res.profileData.disable_date).utc().format("YYYY-MM-DD") : "";
						if(res.vendorData && res.vendorData.length){
							vm.getAllVendor(vm.clientData.client_id);
						}
					//	vm.getAllClient();
			   		})
				}
				else if(this.brandProfileId){
					let match = this.brandsList.find(brand=>{
						return brand.id == this.brandProfileId
					})
					this.getBrandForId(match,0)
					this.showProfileInfo = true;
					this.calledFromEditBrand = true
				//	this.getAllClient()
				}

		   },
		   getAllVendor(data){
			   var client_id = data;
			   this.isLoading = true
			   const vm = this;

			   this.vendorData.map((vendor, index) => {
				   let data = vm.vendorList.find((e) => e.vendor_name == vendor.vendor_name);
				    vm.vendorData[index].vendor = data
				   vm.vendorData[index].showVendorData = true;
				    vm.selectedAllVendorsList.push(data)
				 //  vm.vendorData[index].reporting_date = moment( vm.vendorData[index].reporting_startdate).utc().format("YYYY-MM-DD")
			   })
			   this.selectedAllVendorsList.forEach((e) => {
				   let data = vm.vendorList.indexOf(e)
				   vm.vendorList.splice(data, 1)
			   })

			   this.isLoading = false

			 //  this.getVendorList()

		   },
		   showVendorForSeller(data){
			   const vm = this;
			   this.sellerData.map((vendor, index) => {
				    let seller = vm.countryList.find((e) => e.country_code == vendor.country_code)
				   vm.sellerData[index].country_code = seller;
			   })
		   },
		   showMerchantName(){
			   const vm = this;
			   this.sellerData.map((seller, index) => {
				   let data = vm.merchantList.find((e) => e.merchant_name == seller.merchant_name)
				   let merchantData = vm.merchantList.find((e) => e.merchant_name == seller.merchant_name && e.merchant_id == seller.merchant_id)
				   vm.sellerData[index].merchant_name = data
				   vm.selectedAllSellersList.push(merchantData)
			   })
			   console.log(this.selectedAllSellersList);
			   this.selectedAllSellersList.forEach((e) => {
				   let data = vm.merchantList.indexOf(e)
				   vm.merchantList.splice(data, 1)
			   })
		   },
		   showProfileForClient(data){
			    const vm = this;
				this.profileData.map((profile, index) => {
					vm.profileData[index].selected_profile = {name:this.profileData[index].profile_brand_name, id:this.profileData[index].profile_id};
					vm.profileData[index].showProfileInfo = true;
					let addedProfile = vm.brandsList.find((e) => profile.profile_brand_name == e.name)
					let indexadded = vm.brandsList.indexOf(addedProfile)
					vm.brandsList.splice(indexadded,1)
					if(profile.disable_date){
						vm.profileData[index].showDate = true;
						vm.profileData[index].active = false;


					//	var now = new Date(Date.parse(profile.disable_date))

					//	var nowUtc = new Date( now.getTime() + (now.getTimezoneOffset() * 60000));

					//	let date = this.convertUTCDateToLocalDate(new Date(profile.disable_date))
						vm.profileData[index].disable_date = moment(profile.disable_date).format('YYYY-MM-DD');
					}
				})
		   },
		   convertUTCDateToLocalDate(date) {
			  var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);
			  var offset = date.getTimezoneOffset() / 60;
			  var hours = date.getHours();
			  newDate.setHours(hours - offset);
			  return newDate;
		  },
		   selectVendorForSeller(data, index){
			   this.isVendorSellerLoading = true;
			   this.sellerData[index].vendor = data;
			   this.isVendorSellerLoading = false;
		   },
		   getVendorList(){
			   const vm = this;
			   this.$store.dispatch("getAccountVendors").then(res=>{
				   vm.vendorList = res.filter(e=>e.vendor_name);
				   vm.vendorListCopy = JSON.parse(JSON.stringify(vm.vendorList))
				//   vm.vendorData.vendor = res.find((e) => e.go_client_id == data)
				   vm.isLoading = false;
			   })
		   },
		   addNewVendor(data, index){
			   if(index == this.ispreviouslySelectedVendor){
				   this.ispreviouslySelectedVendor = ''
			   }
			    this.ispreviouslySelectedVendor = ''
			   let isAlreadtPresentVendor
			   this.vendorData.forEach((e, vendorIndex) => {
				   if(vendorIndex!=index){
					   if(e.vendor_name.toLowerCase().trim() === data.toLowerCase().trim())
							isAlreadtPresentVendor = e
				   }

			   })

			  if(isAlreadtPresentVendor){
				  this.ispreviouslySelectedVendor = index
			  }
			  else{
				  this.vendorData[index].showVendorData = true
				  this.vendorData[index].vendor= {vendor_name: data}
				  this.vendorData[index].vendor_name= data
				  this.vendorList.push({vendor_name:data});
				  this.vendorData[index].go_vendor_cd = '';
				  this.vendorData[index].vc_alias = '';
				  this.vendorData[index].account_type = '';
				  this.vendorData[index].reporting_date = '';
				  this.vendorData.splice(0,0)
			  }

		   },
		   selectNewVendor(data, index){
			   let vm = this;
			   if(index == this.ispreviouslySelectedVendor){
				   this.ispreviouslySelectedVendor = ''
			   }
			   this.vendorList = JSON.parse(JSON.stringify(this.vendorListCopy));
			   this.selectedAllVendorsList = []
			   this.vendorData.forEach((e, vendorIndex) => {
				   if(vendorIndex!=index && e.vendor && e.vendor.vendor_name){
					   let listData = vm.vendorList.find((list) => list.vendor_name.toLowerCase() === e.vendor.vendor_name.toLowerCase())
					   this.selectedAllVendorsList.push(listData)
				   }
			   })

			   this.selectedAllVendorsList.push(data)

			   this.selectedAllVendorsList.forEach((e) => {
				   if(e && e.vendor_name){
					   let selectedData = vm.vendorList.find((vendor) => vendor.vendor_name.toLowerCase() == e.vendor_name.toLowerCase())
					   let selectedDataIndex = vm.vendorList.indexOf(selectedData)
					   vm.vendorList.splice(selectedDataIndex, 1)
				   }
				  })


				  this.isLoading = true;
				  let obj = {}
				  if(data.id){
				  	obj.go_vendor_cd = data.id;
				  	obj.vendor_name = data.vendor_name;
				  	obj.vc_alias = data.vc_alias;
				  	obj.account_type = data.account_type;
					obj.showVendorData = true;
				  	obj.reporting_date = data.reporting_startdate ? moment(data.reporting_startdate).utc().format("YYYY-MM-DD") : '';
				  		this.vendorData[index] = obj;
				  }
				  this.vendorData[index].vendor = data;
				  let val = JSON.parse(JSON.stringify(this.vendorData));
				  this.vendorData = val;
				  this.isLoading = false;
				  this.vendorData.splice(0,0)
		   },
		   removeSelectedVendor(data, index){
			   // let addedVendor = this.vendorList.find((e) => e == data)
			   // if(!addedVendor){
				//    this.vendorList.push(data.vendor)
			   // }

			   this.vendorData[index].go_vendor_cd = '';
			   this.vendorData[index].vendor_name = '';
			   this.vendorData[index].vc_alias = '';
			   this.vendorData[index].account_type = '';
			   this.vendorData[index].reporting_date = '';
			   this.vendorData.splice(0,0)
		   },
		   getAllClient(data){
			   this.isLoadingClient = true
			   const vm = this;
			   this.$store.dispatch("getAccountClient").then(res=>{
				   vm.clientList = res.filter(e=>e.client_name);
				  // vm.clientData.client = res.find((e) => e.client_id == data)
				   vm.isLoadingClient = false;
			   })
		   },
		   selectNewClient(data){
			//   this.getAllVendor(data.client_id);
			   if(this.showProfileInfo){
				   this.client_id = data.client_id;
				   this.getProfileData();
			   }
			   else{
				   this.isLoadingClient = true;
				   this.vendorData.clientData  = data;
				   this.isLoadingClient = false;
			   }
		   },
		   addNewClient(data){
			   if(this.calledFromEditBrand){
				   this.sellerData = [];
				   this.vendorData = [];
				   this.profileData =  this.profileData.splice(0,1);

			   }
			   this.clientData.client= {client_name: data}
			   this.clientList.push({client_name:data});
		   },
		   addVendorToList(){
			   this.vendorData.push({
				   go_vendor_cd:"",
				   vendor_name:"",
				   vc_alias:"",
				   account_type:"",
				   reporting_date:"",
				   vendor:null,
				   showVendorData:false,
				   isRemove:false,
				   forProfile:'',
				   forSeller:''
			   })
		   },
		   addSellerToList(){
			   let vm = this;
			   // this.merchantList = JSON.parse(JSON.stringify(this.merchantListCopy))
			   //
			   // this.selectedAllSellersList.forEach((e) => {
				//    let data = vm.merchantList.find((seller) => seller.name == e.name)
				//    let index = vm.merchantList.indexOf(data)
				//    vm.merchantList.splice(index, 1)
			   // })

			   this.sellerData.push({
				   id:"",
				   merchant_id:"",
				   merchant_type:"",
				   country_code:null,
				   marketplace_id:"",
				   marketplace_url:"",
				   access_key_id:"",
				   secret_access_key:"",
				   seller_dev_auth_token:"",
				   merchant_name:null,
				   duplicateNameKeyPair:false
			   })
		   },
		   removeVendorFromList(index){
			   if(index == this.ispreviouslySelectedVendor){
				   this.ispreviouslySelectedVendor = ''
			   }
			   if(this.vendorData[index].vendor){
				   let data = this.vendorData[index].vendor
				   this.vendorList.push(data)
			   }

			   this.vendorData.splice(index, 1)
		   },
		   removeSellerFromList(index){
			   this.sellerData[index].duplicateNameKeyPair = false
			   // if(index == this.duplicateNameKeyPair){
				//    this.duplicateNameKeyPair = ''
			   // }

			   let obj = this.sellerData[index]
			   if(obj.merchant_name && obj.merchant_name.name){
				   this.sellerData.splice(index, 1)
				   let listData = this.merchantListCopy.find((list) => list.merchant_name.toLowerCase() == obj.merchant_name.merchant_name.toLowerCase())
				   this.merchantList.push(listData)
			   }
			   else{
				   this.sellerData.splice(index, 1)
			   }

		   },
		   addNewVendorToSeller(data, index){
			   this.isVendorSellerLoading = true
			   this.sellerData[index].vendor  = {vendor_name:data}
			   this.isVendorSellerLoading = false
		   },
		   addNewMerchant(data, index){
			   let isAlreadyAdded
			   this.sellerData.forEach((e, sellerIndex) => {
				   if(sellerIndex!=index){
					   if(e.merchant_name.merchant_name.toLowerCase() === data.toLowerCase())
					   		isAlreadyAdded = e
				   }

			   })

			   if(isAlreadyAdded){
				   this.sellerData[index].merchant_name = isAlreadyAdded.merchant_name;
				   this.sellerData[index].merchant_id = isAlreadyAdded.merchant_id;
				   this.sellerData[index].id = '';
				   let country = this.countryList.find((e) => e.country_code == isAlreadyAdded.country_code.country_code);
				   this.sellerData[index].country_code = country
				   this.sellerData[index].seller_dev_auth_token = isAlreadyAdded.seller_dev_auth_token;
				   this.sellerData[index].duplicateNameKeyPair = true
				   this.sellerData.splice(0,0)
			   }
			   else{
				   this.sellerData[index].duplicateNameKeyPair = false
				   this.merchantList.push({merchant_name:data})
				   this.sellerData[index].merchant_name = {merchant_name:data}
				   this.sellerData[index].merchant_id = '';
				   this.sellerData[index].country_code = {};
				   this.sellerData[index].seller_dev_auth_token = '';
				   this.sellerData[index].id = '';
				   this.merchantList.splice(0,0)
			   }

		   },
		   checkDuplicasy(eventData, index){
			   let tempData = JSON.parse(JSON.stringify(this.sellerData))
			   tempData.splice(index, 1)
			   let data = tempData.find((e) => e.merchant_id && e.merchant_id.toLowerCase().trim() === this.sellerData[index].merchant_id.toLowerCase().trim());
			   if(data){
				    this.sellerData[index].duplicateNameKeyPair = true
			   }
			   else{
				this.sellerData[index].duplicateNameKeyPair = false
			   }
		   },
		   selectMerchantName(data, index){
			   let vm = this;
			   this.sellerData[index].duplicateNameKeyPair = false
			   this.sellerData[index].merchant_id = data.merchant_id;
			   this.sellerData[index].id = data.id;
			   let country = this.countryList.find((e) => e.country_code == data.country_code);
			   this.sellerData[index].country_code = country
			   this.sellerData[index].seller_dev_auth_token = data.seller_dev_auth_token;


			//	let selectedData = this.merchantList.indexOf(data)
				this.selectedAllSellersList = [];
				this.merchantList = JSON.parse(JSON.stringify(this.merchantListCopy))

				// let isDuplicate = this.sellerData.find((e) => e.merchant_name.merchant_name === data.merchant_name && data.merchant_id == e.merchant_id)

			//	let isDuplicateInList = this.merchantList.find((e) => e.merchant_name === data.merchant_name)
				//
				// if(isDuplicate){
				// 	this.duplicateNameKeyPair = index
				// }

				this.sellerData.forEach((e, sellerIndex) => {
					if(sellerIndex!=index && e.merchant_name && e.merchant_name.merchant_name){
						let listData = vm.merchantList.find((list) => list.merchant_name === e.merchant_name.merchant_name)
						vm.selectedAllSellersList.push(listData)
					}

				})
				this.selectedAllSellersList.push(data)

				this.selectedAllSellersList.forEach((e) => {
 				   let selectedData = vm.merchantList.find((seller) => seller.merchant_name == e.merchant_name)
 				   let selectedDataIndex = vm.merchantList.indexOf(selectedData)
 				   vm.merchantList.splice(selectedDataIndex, 1)
 			   })
				this.merchantList.splice(0,0)
		   },
		   removeSelectedSeller(data, index){
			   // let selectedData = this.selectedAllSellersList.indexOf(data)
			   // this.selectedAllSellersList.splice(selectedData, 1)
			   // this.merchantList = JSON.parse(JSON.stringify(this.merchantListCopy))
			   //
			   // this.selectedAllSellersList.forEach((e) => {
				//    let data = this.merchantList.indexOf(e)
				//    this.merchantList.splice(data, 1)
			   // })

			   this.sellerData[index].merchant_id = '';
			   this.sellerData[index].id = '';
			   this.sellerData[index].country_code = {};
			   this.sellerData[index].country_code = {};
			   this.sellerData[index].seller_dev_auth_token = '';

		   },
		   validate() {
			   let isNoNewVendorName = this.vendorData.find(e=> !e.vendor_name)
			   let isSellerMerchantId = this.sellerData.find(e=> !e.merchant_id)
			   let isDuplicateIndex = this.sellerData.find(e=> e.duplicateNameKeyPair)
			   if (
				   ((!this.clientData.client_name) && (!this.clientData.client || (this.clientData.client && !this.clientData.client.client_name))) || (this.vendorData.length && isNoNewVendorName != undefined) || (!this.selected_profile) || (this.sellerData.length && isSellerMerchantId != undefined ) || (isDuplicateIndex!=undefined) || (this.ispreviouslySelectedVendor)
			   ) {
				   return false;
			   } else {
				   return true;
			   }
		   },
		   removeProfileToList(index){
			   let profile_name = this.profileData[index].profile_brand_name;


			   let addedProfile = this.brandListCopy.find((e) => e.name == profile_name)
			   this.brandsList.push(addedProfile)

			   this.profileData.splice(index, 1)
		   },
		   addProfileToList(){
				let obj =  {
   					profile_id: "",
   					vendor: "",
   					go_vendor_cd: "",
   					ams_profile_id: "",
   					brand_entity_id: "",
   					profile_brand_name: "",
   					active: true,
   					country_code: "",
   					base_api_url: "",
   					profile_type_seller: "",
   					profile_type_vendor: "",
   					marketing_campaign_sp: "",
   					marketing_campaign_sb: "",
   					marketing_campaign_sd: "",
   					ara_type: "",
   					client_main_contact: "",
   					profile_type: "",
   					data_pull: "",
   					go_retail: "",
   					go_vendor: "",
   					go_marketing: "",
   					go_ops: "",
   					annual_goal: '',
   					fba:'',
   					montly_budget:'',
   					disable_date:'',
   					selected_profile:{},
					showProfileInfo:false,
					gettingProfileInfo:false,
					showDate:false
   				}

			   this.profileData.push(obj)
		   },
		   resetWithNewProfile(index){
			   let obj = {
				   profile_id: "",
				   vendor: "",
				   go_vendor_cd: "",
				   ams_profile_id: "",
				   brand_entity_id: "",
				   profile_brand_name: "",
				   active: true,
				   country_code: "",
				   base_api_url: "",
				   profile_type_seller: "",
				   profile_type_vendor: "",
				   marketing_campaign_sp: "",
				   marketing_campaign_sb: "",
				   marketing_campaign_sd: "",
				   ara_type: "",
				   client_main_contact: "",
				   profile_type: "",
				   data_pull: "",
				   go_retail: "",
				   go_vendor: "",
				   go_marketing: "",
				   go_ops: "",
				   annual_goal: '',
				   fba:'',
				   montly_budget:'',
				   disable_date:'',
				   showProfileInfo:false,
				   gettingProfileInfo:false,
				   showDate:false
			   }
			   this.profileData[index] = JSON.parse(JSON.stringify(obj))
		   },
		   getCountryList(){
			   let vm = this;
			   this.$store.dispatch("accounts/getCountryList").then((res) => {
				   vm.countryList = res;
				   let data = vm.countryList.find((e) => e.market_place == 'US')
				   let index = vm.countryList.indexOf(data)
				   vm.countryList.splice(index, 1)
				   vm.countryList.unshift(data)

			   })
		   },
		   getMerchantList(){
			   this.$store.dispatch("accounts/getMerchantNameList").then((res) => {
				   this.merchantList = JSON.parse(JSON.stringify(res))
				   this.merchantListCopy = JSON.parse(JSON.stringify(res))
			   })
		   }
		}
	}

</script>

<style lang="scss">

.change-color{
	background-color: #f6f8f7;
	border: 1px #27c475 solid !important
}
.date_wrapper {
	.text-muted {
		border:0px;
		margin:0px
	}
}

.date_wrapper {
	.text-break {
		border: none;
		margin:0px
	}
}
::placeholder {
    color: #aaa !important;
    font-size: 14px;
}


</style>
